
import { Component, OnInit } from '@angular/core';
import { FinanzasService } from 'app/finanzas/finanzas.service';

export class prueba{
    resultado: number;
}


@Component({
    selector: 'app-informeFinanzas', 
    templateUrl: 'informe.component.html',
    styleUrls: ['./informe.component.css']
})

export class InformeComponent implements OnInit{
    

    constructor(private service: FinanzasService ){  }

    ngOnInit(){
    
    }

    
}
